import React, { useEffect, useState, useRef } from "react";
import { useRouter } from "@src/lib/router";
import { useSwipeable } from "react-swipeable";

import { getCourseOverviewService } from "@src/components/Tabs/Overview/store/services";
import { executeQuery } from "@src/graphApis/graph";

import { useDispatch, useSelector } from "react-redux";

import { getTabListAction } from "@src/components/UIElements/TabBar/store/actions";
import {
  getCourseCouponStudentOverviewService,
  getTabListService,
} from "@src/components/UIElements/TabBar/store/services";
import tranformTabList from "@src/components/UIElements/TabBar/store/transformer";

import { setPageHeadingAction } from "@src/layout/store/actions";
import {
  getCourseCouponListStudent,
  getCourseCouponStudentOverview,
} from "@src/graphApis";
import { getAddressListAction } from "@src/components/PhysicalAddress/store/actions";
import { hitHapticFeedback } from "@src/utils";
import { setFreeTrialBottomsheetOpenViaTabSwitch, showFreeTrialBottomSheetAction } from "@src/components/BottomSheets/store/actions";
import { COURSE_TABS_ENUMS } from "@src/utils/constants";
import { updateWebBackEventStatus } from "@src/components/Tabs/Overview/components/OverviewContent/utility";

import TabBar from "@src/components/UIElements/TabBar";
import TabShimmer from "@src/components/UIElements/TabShimmer/TabShimmer";
import RetryPayment from "@src/components/Tabs/Overview/components/RetryPayment/RetryPayment";
import SwitchTabs from "@src/components/Tabs";

const CourseTabHome = ({ props }) => {
  // NEXTJS ROUTER
  const router = useRouter();

  // DISPATCH
  const dispatch = useDispatch();

  // LOCALSTATES
  const [activeTab, setActiveTab] = useState(1);

  // SELECTOR
  const tabList = useSelector((state) => {
    if (state?.tabBarReducer?.tabList?.length) {
      return state?.tabBarReducer?.tabList
    } else {
      return props?.tabListData;
    }
  });
  const courseName = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.details?.name
  );
  const isStandAlone = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.doubtBuddyCourseFlag ) || false;
  const isPullToRefreshTriggered = useSelector(
    (state) => state?.pullToRefreshReducer?.isPullToRefreshTriggered
  );
  const offlineMaterialFlag = useSelector(state => state?.overviewReducer?.overViewDetails?.course?.metaData?.offlineMaterialFlag);

  const paymentStatusEmblem1 = useSelector(state => state?.overviewReducer?.overViewDetails?.course?.paymentStatusEmblem1);
  const tabIdArray = useSelector((state) => {
    if (state?.tabBarReducer?.tabList?.length) {
      return state?.tabBarReducer?.tabList?.map((tab) => tab?.id);
    }
    return props?.tabListData?.map?.((tab) => tab?.id) || [];
  });
  const trialTabData = tabList?.find((tab) => tab.enumKey === COURSE_TABS_ENUMS.TRIAL_CONTENT);
  const isIdfysDocVerification = useSelector(state => state?.overviewReducer?.overViewDetails?.course?.metaData?.verificationDetails?.postPurchase?.isVerificationRequired) || false;
  const isIdfysDocVerificationPrepurchase = useSelector(state => state?.overviewReducer?.overViewDetails?.course?.metaData?.verificationDetails?.prePurchase?.isVerificationRequired) || false;
  const overViewDetailsLoading = useSelector((state) => state?.overviewReducer?.overViewDetails?.course?.orgDetails);

  // FUNTIONS
  const changeTab = (value) => {
    if(isIdfysDocVerification || !overViewDetailsLoading) {
      return
    }
    if(isIdfysDocVerificationPrepurchase) {
      router.push(`/${router?.query?.courseId}/${1}`);
      return
    }
    hitHapticFeedback();
    if (!Array.isArray(tabIdArray) || tabIdArray.length === 0) return;
    const currentIndex = tabIdArray.indexOf(activeTab);
    if (currentIndex < 0) return;
    const nextTab = tabIdArray[currentIndex + value];

    if (activeTab === 1 && value < 0) {
      // router.push(`/${router?.query?.courseId}/${tabList?.length}`);
    } else if (activeTab === tabList?.length && value > 0) {
      // router.push(`/${router?.query?.courseId}/1`);
    } else if (!nextTab) {
      // do nothing
    } else if(nextTab == 5 && trialTabData?.isLocked ){
      dispatch(setFreeTrialBottomsheetOpenViaTabSwitch(true))
      dispatch(showFreeTrialBottomSheetAction(true))
    } else {
      updateWebBackEventStatus(false)
      router.push(`/${router?.query?.courseId}/${nextTab}`);
    }
  };

  // const isInitialMount = useRef(true);
  useEffect(() => {
    //To prevent multiple api calls
    // if (isInitialMount.current) {
    // isInitialMount.current = false;
    // } else {
    if (router?.query?.courseId) {
      dispatch(
        getTabListAction({
          courseId: router?.query?.courseId,
          skipLoader: true,
        })
      );
      dispatch(getAddressListAction());
    }
    // }
  }, [router?.query?.courseId]);

  React.useEffect(() => {
    if(typeof window != "undefined" && trialTabData && trialTabData.isLocked){
      updateWebBackEventStatus(true)
    }
    return () => {
      updateWebBackEventStatus(false)
    }
  }, [router.isReady])

  // HANDLING PULL TO REFRESH ACTION
  React.useEffect(() => {
    if (isPullToRefreshTriggered) {
      if (router?.query?.courseId) {
        dispatch(
          getTabListAction({
            courseId: router?.query?.courseId,
            skipLoader: true,
          })
        );
      }
    }
  }, [isPullToRefreshTriggered]);

  useEffect(() => {
    if (
      activeTab > 0 &&
      activeTab != router?.query?.tabId &&
      router?.query?.tabId > 0
    ) {
      console.log("router.query.tabId", router.query.tabId);
      setActiveTab(parseInt(router?.query?.tabId));
    }
  }, [router.query.tabId]);

  const swipeActions = useSwipeable({
    onSwipedLeft: (e) => {
      let flag = true;
      const path =
        e?.event?.path || (e?.event.composedPath && e?.event.composedPath()); // COMPOSED PATH FOR iOS
      path?.forEach((ele) => {
        // SVG className is SVGAnimatedString, not a string — .includes throws
        if (ele?.classList?.contains("blockSlide")) flag = false;
      });
      if (flag) changeTab(1);
    },
    onSwipedRight: (e) => {
      let flag = true;
      const path =
        e?.event?.path || (e?.event.composedPath && e?.event.composedPath()); // COMPOSED PATH FOR iOS
      path?.forEach((ele) => {
        if (ele?.classList?.contains("blockSlide")) flag = false;
      });
      if (flag) changeTab(-1);
    },
    delta: 50,
  });

  useEffect(() => {
    window.updateBuildInfo = (dataObj) => {
     window.androidData = dataObj;
    };
    
    // event listener for message from android
    return () => {
      dispatch(setPageHeadingAction(""));
    };
  }, []);

  useEffect(() => {
    if (courseName) {
      dispatch(setPageHeadingAction(courseName));
    }
  }, [courseName]);

  return (
    <div className="SwipingPage">
      { !isStandAlone && (tabList?.length ? (
        <TabBar
          list={tabList}
          active={activeTab}
          setTab={(e) => router.push(`/${router?.query?.courseId}/${e}`)}
        />
      ) : offlineMaterialFlag ? null : (
        <TabShimmer />
      ))}
      {(activeTab === 1 && paymentStatusEmblem1 && Object.keys(paymentStatusEmblem1).length) ? <RetryPayment data={paymentStatusEmblem1}/> : null}
      <div style={{ minHeight: "80vh" }} {...swipeActions}>
        <SwitchTabs
          activeTab={activeTab}
          overviewServerData={props?.overviewData}
          getCourseCouponListStudentDataServer={
            props?.getCourseCouponListStudentData
          }
        />
      </div>
    </div>
  );
};

//Disabled all backend api calls, all api calls are made from front end only.
CourseTabHome.getInitialProps__ = async (context) => {
  const forwardedHeaders = context?.req?.headers;
  // REDIRECTING TO OVERVIEW TAB IF TAB ID IS GREATOR THAN 4
  if ((context?.query?.tabId > 4 || context?.query?.tabId == 6) || isNaN(context?.query?.tabId)) {
    return {
      redirect: {
        permanent: true,
        destination: `/${context.query.courseId}/1`,
      },
    };
  }

  // SERVER SIDE RENDERING THE OVERVIEW AND TAB LIS IF TOKEN IS PRESENT IN URL
  if (context?.query?.token) {
    // FETCHING OVERVIEW AND TAB LIST DATA ON SERVER

    const [
      overviewData,
      tabListData,
      getCourseCouponListStudentData,
      getCourseCouponStudentOverviewData,
    ] = await Promise.allSettled([
      getCourseOverviewService(
        {
          courseId: context.query.courseId,
          token: context.query.token,
          region: context.query.region,
          defaultLanguage: context.query.defaultLanguage,
        },
        forwardedHeaders
      ),
      getTabListService({
        courseId: context.query.courseId,
        token: context.query.token,
        region: context.query.region,
        defaultLanguage: context.query.defaultLanguage,
      }),
      executeQuery({
        variables: {
          courseId: context.query.courseId,
          token: context.query.token,
          region: context.query.region,
          defaultLanguage: context.query.defaultLanguage,
          limit: 20,
          offset: 0,
        },
        query: getCourseCouponListStudent,
      }),
    ]);

    return {
      props: {
        overviewData: overviewData?.value?.data?.data || {},
        tabListData:
          tranformTabList(tabListData?.value?.data?.data?.tabs) || {},
        getCourseCouponListStudentData:
          getCourseCouponListStudentData?.value?.data?.data || {},
        getCourseCouponStudentOverviewData:
          getCourseCouponStudentOverviewData?.value?.data?.data || {},
      },
    };
  }
  return { props: {} };
};

// LAYOUTPROPS

export default CourseTabHome;
